/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.18",
    versionName: "0.4.0-nightly.2026.6.18",
    versionChannel: "nightly",
    buildDate: "2026-06-18T00:44:09.010Z",
    commitHash: "bca811a9e85db01d2225dc22ef22e7ee7215e624",
};
